<template>
  <div
    v-if="!isPremium"
    class="ad-pc mt-4"
  >
    <div
      ref="ads"
    >
      <router-link
        to="/input-card"
      >
        <v-img
          src="../assets/banner.jpg"
          max-width="300px"
        />
      </router-link>
      <img
        alt=""
        border="0"
        height="1"
        src="https://www18.a8.net/0.gif?a8mat=1U7H4L+8LLFCI+2HOM+BS629"
        width="1"
      >
    </div>
    <!--    <Adsense
            style="width:250px;height: 100%"
            data-ad-client="ca-pub-5152865430457107"
            data-ad-slot="8539426925"
        />-->
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'AdPc',
  components: {},
  data() {
    return {
      a8scriptText:
      "<script type=\"text/javascript\">\n" +
          "var adstir_vars = {\n" +
          "  ver: \"4.0\",\n" +
          "  app_id: \"MEDIA-c7a82f89\",\n" +
          "  ad_spot: 1,\n" +
          "  center: false\n" +
          "};\n" +
          "<\/script>"+
"<script type=\"text/javascript\" src=\"https://js.ad-stir.com/js/adstir.js\"><\/script>",
      admaxScriptText:
          "<script src=\"https://adm.shinobi.jp/s/f3e66be523dfdd564ece9fcb8cf52ea7\"><\/script>",
      amazonScriptText: "<script type=\"text/javascript\">amzn_assoc_ad_type =\"responsive_search_widget\"; amzn_assoc_tracking_id =\"neconotech09-22\"; amzn_assoc_marketplace =\"amazon\"; amzn_assoc_region =\"JP\"; amzn_assoc_placement =\"\"; amzn_assoc_search_type = \"search_widget\";amzn_assoc_width =\"300\"; amzn_assoc_height =\"350\"; amzn_assoc_default_search_category =\"KindleStore\"; amzn_assoc_default_search_key =\"\";amzn_assoc_theme =\"light\"; amzn_assoc_bg_color =\"FFFFFF\"; <\/script><script src=\"https://z-fe.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&Operation=GetScript&ID=OneJS&WS=1&Marketplace=JP&internal=1\"><\/script>",
      scriptText:
          "<script type=\"text/javascript\">rakuten_design=\"slide\";rakuten_affiliateId=\"1d72115b.b39342ba.1d72115c.84dadc44\";rakuten_items=\"ranking\";rakuten_genreId=\"402853\";rakuten_size=\"300x250\";rakuten_target=\"_blank\";rakuten_theme=\"gray\";rakuten_border=\"off\";rakuten_auto_mode=\"on\";rakuten_genre_title=\"off\";rakuten_recommend=\"on\";rakuten_ts=\"1613538928610\";<\/script><script type=\"text/javascript\" src=\"https://xml.affiliate.rakuten.co.jp/widget/js/rakuten_widget.js\"><\/script>"
    }
  },
  async mounted() {
    if (!this.isPremium) {

      const iframe0 = document.createElement('iframe');
      iframe0.setAttribute("frameborder", "0")
      iframe0.setAttribute("width", "310")
      iframe0.setAttribute("height", "270")
      this.$refs.ads.appendChild(iframe0);
      const html0 = `<body>${this.a8scriptText}<\/body>`;
      const iframe0Document = iframe0.contentWindow.document;
      iframe0Document.open();
      iframe0Document.write(html0);
      iframe0Document.close();




      // const iframe2 = document.createElement('iframe');
      // iframe2.setAttribute("frameborder", "0")
      // iframe2.setAttribute("width", "320")
      // iframe2.setAttribute("height", "350")
      // this.$refs.ads.appendChild(iframe2);
      // const html2 = `<body style="margin:auto;padding;0px">${this.amazonScriptText}<\/body>`;
      // const iframeDocument2 = iframe2.contentWindow.document;
      // iframeDocument2.open();
      // iframeDocument2.write(html2);
      // iframeDocument2.close();

      const iframe1 = document.createElement('iframe');
      iframe1.setAttribute("frameborder", "0")
      iframe1.setAttribute("width", "320")
      iframe1.setAttribute("height", "250")
      this.$refs.ads.appendChild(iframe1);
      const html = `<body style="margin:auto;padding;0px">${this.scriptText}<\/body>`;
      const iframeDocument = iframe1.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(html);
      iframeDocument.close();

    }

  },
  computed: {
    ...mapState({
      isPremium: state => state.userModule.isPremium
    })
  },
  methods: {}
}
</script>

<style>
.ad-pc {
  /*width: 100%;*/
  height: 100%;
}
iframe{
  padding:0px;
  margin:0px;
}

/* 画面サイズの横幅が 768px より大きい場合に適用 */
@media screen and (min-width: 960px) {
  .ad-pc {
    display: block;
  }
}

/* 画面サイズの横幅が小さい場合に適用 */
@media screen and (max-width: 960px) {
  .ad-pc {
    display: none;
  }
}
</style>
